import { formatMessage } from './strings/intl/intlHooks'
import { messages } from './strings/messages'
import { PASSWORD_LENGTH } from './lengths'

const EMAIL_FORMAT_REGEX =
  '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'

export const CPF_CONSTRAINT = {
  cpf: {
    message: `^${formatMessage(messages.error_invalidCPF)}`,
  },
  presence: {
    message: `^${formatMessage(messages.error_CPFMissing)}`,
  },
}

export const EMAIL_CONSTRAINT = {
  presence: {
    message: `^${formatMessage(messages.error_emailMissing)}`,
  },
  format: {
    pattern: EMAIL_FORMAT_REGEX,
    message: `^${formatMessage(messages.error_emailFormat)}`,
  },
}

export const PASSWORD_CONSTRAINT = {
  length: {
    minimum: PASSWORD_LENGTH,
    message: `^${formatMessage(messages.error_passwordMinLength)}`,
  },
  presence: {
    message: `^${formatMessage(messages.error_passwordMissing)}`,
  },
}

export const PASSWORD_CONFIRMATION_CONSTRAINT = {
  equality: {
    attribute: 'newPassword',
    message: `^${formatMessage(messages.error_differentPasswords)}`,
  },
}

export const CURRENT_PASSWORD = {
  ...PASSWORD_CONSTRAINT,
  equalityToCurrentPassword: {
    message: `^${formatMessage(messages.error_currentPassword)}`,
  },
}
